import { Reference } from "./SystemEntities";

// ----------------------------------------------------------------------------
// register

export class NewAccountRequest {
	registration: Registration;
	reCaptchaToken: string;
}

export class NewAccountResponse {
	isError: boolean;
	message: string;
}

export class RegistrationRefData {
	linesOfBusiness: Reference[];
	branches: Reference[];
	isMaintenanceMode: boolean = false;
	productOfInterests: Reference[];
	errorMessage: string;
}

export class AddressSearchResponse {
	addressSearchResults: Reference[];
	errorMessage: string;
}

export class AddressMetadataResponse {
	address: RegistrationAddress;
	errorMessage: string;
}

export class Registration {
	registrationType: string;
	organisationType: string = "Other";
	firstName: string;
	lastName: string;
	accountName: string;
	knownAs: string;
	preferredBranch: string;
	lineOfBusiness: string;
	productsOfInterest: string;
	websiteUrl: string;
	phoneNumber: string;
	mobileNumber: string;
	invoiceEmail: string;
	webshopEmail: string;
	deliveryAddress: RegistrationAddress;
	postalAddress: RegistrationAddress;
	registeredAddress: RegistrationAddress;
	accountId: string;
	capricornAccountNumber: string;
	dateOfBirth: string;
	nzbn: string;
	businessAge: string;
	monthlyRevenue: string;
	contactPerson: string;
	directors: string;
	consultants: string;
	licenceNumber: string;
	licenceVersion: string;
	agreeCreditNotice: boolean;
	sthlContact: string;
	sameAsPostal: boolean;
	useContactAbove: boolean;
	notificationContactFirstName: string;
	notificationContactLastName: string;
	notificationContactPhoneNumber: string;
	notificationContactEmailAddress: string;
	receiveTextMessage: boolean;
	additionalContacts: RegistrationNotificationContact[] = [];
}

export class RegistrationAddress {
	street: string = "";
	suburb: string = "";
	city: string = "";
	postCode: string = "";
	country: string = "NZL";
}

export class RegistrationPhoneNumber {
	countryCode: string = "+64";
	number: string = "";
}

export class RegistrationNotificationContact {
	firstName: string = "";
	lastName: string = "";
	emailAddress: string = "";
	phoneNumber: string = "";
	emailNotificationPreferences: string[] = [];
	receiveTextNotifications: boolean;
}

